<cpc-policy-card [ngClass]="state.name" [variant]="state.badge">
  <cpc-policy-card-header class="cpc-policy-card-header_{{state.badge}}">
    <cpc-icon left [icon]="getGroupByLobId(policy.lineOfBusinessId).icon"
      color="{{ (policy.isElectricVehicle) ? '#3da556' : '#006192' }}" borderStyle="circle" backgroundColor="#fff"></cpc-icon>
    <ng-container center>
      <p translate *ngIf="!policy.isElectricVehicle">{{'active-insurance-group.' + getGroupByLobId(policy.lineOfBusinessId).name}}</p>
      <p translate *ngIf="policy.isElectricVehicle">{{'active-insurance-group.car-insurance-ek'}}</p>
      <container-element [ngSwitch]="LOB.setId(policy.lineOfBusinessId).lob">
        <h2 *ngSwitchCase="lob.CarInsurance">{{policy.model | stringFormat}}&nbsp;- {{policy.crn | stringFormat}}</h2>
        <h2 *ngSwitchCase="lob.LifeInsurance">{{policy.firstInsuredName | stringFormat}}</h2>
        <h2 *ngSwitchCase="lob.HomeInsurance">{{policy.householdAddress | stringFormat}}</h2>
      </container-element>
    </ng-container>
    <ng-container right>
      <div>
        <cpc-badge [variant]="state.badge">
          {{'product-state.' + state.name | translate}}
          <cpc-icon icon="check-circle"></cpc-icon>
        </cpc-badge>
      </div>
    </ng-container>
  </cpc-policy-card-header>
  <cpc-policy-card-content class="policy-card-content" [borderBottom]="state === policyStates.active ? true : false">
    <cpc-policy-card-entry skipFromHeightAligment="true">
      <span title translate>home.product-name</span>
      <b>{{policy.productNameSpecific | stringFormat}}</b>
    </cpc-policy-card-entry>
    <cpc-policy-card-entry skipFromHeightAligment="true">
      <span title translate>policy.policy-number</span>
      <b>{{policy.policyNumber}}</b>
    </cpc-policy-card-entry>
    <ng-template [ngIf]="!!policy.endDate">
      <cpc-policy-card-entry [fullWidth]="true">
        <cpc-policy-progress [startDate]="policy.beginDate" [endDate]="policy.endDate" [isActiveBar]="policy.policyState.name == policyStates.active.name"
          copyStart="{{'policy.start-date' | translate}}" copyEnd="{{'policy.end-date' | translate}}"></cpc-policy-progress>
      </cpc-policy-card-entry>
    </ng-template>
    <ng-template [ngIf]="!policy.endDate">
      <cpc-policy-card-entry skipFromHeightAligment="true">
        <span title translate>policy.start-date</span>
        <b>{{policy.beginDate | dateFormat}}</b>
      </cpc-policy-card-entry>
    </ng-template>

    <div class="button-row">
      <a href="{{'file-a-claim.'+commonService.env+'.lob_' + policy.lineOfBusinessId + responsibility | translate}}" target="_blank" *ngIf="policy.canFileAClaim">
        <button nxPlainButton type="button" class="file-a-claim" (click)="gtm()">
          {{'policy.file-a-claim' | translate}}<nx-icon name="launch" class="nx-margin-left-2xs"></nx-icon>
        </button>
      </a>
      <a [routerLink]="['/moje-poistky', policy.policyState.name, policy.policyNumber]">
        <button nxButton="secondary small" type="button">
          {{'policy.details' | translate}}
        </button>
      </a>
    </div>
  </cpc-policy-card-content>
</cpc-policy-card>
